export default "__VITE_ASSET__C5Gr3SBV__"